import { render, staticRenderFns } from "./CountryTranslationNewPopup.vue?vue&type=template&id=315068ac&"
import script from "./CountryTranslationNewPopup.vue?vue&type=script&lang=js&"
export * from "./CountryTranslationNewPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports